export default __webpack_public_path__ + "static/media/tick-circle.inline.7c497810.svg";